
import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import condizionatore from '../../asset/servizi/condizionatore.png'
import piscina from '../../asset/servizi/piscina.png'
import caldaia from '../../asset/servizi/caldaia.png'
import tubature from '../../asset/servizi/tubature.png'
import videoispezioni from '../../asset/servizi/videoispezioni.png'


const CardSlider = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cards = [
    {
      image: condizionatore,
      title: 'Condizionatori'
    },
    {
      image: piscina,
      title: 'Piscine e impianti di irrigazione'
    },
    {
      image: caldaia,
      title: 'Caldaie e stufe a pellet'
    },
    {
      image: tubature,
      title: 'Ristrutturazione bagni e tubature'
    },
    {
      image: videoispezioni,
      title: 'videoispezioni'
    }
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true
  };

  return (
    <div className="pt-20">
      {/* Desktop View - mostra tutte le card in riga */}
      {!isMobile && (
        <div className="flex flex-row gap-4">
          {cards.map((card, index) => (
            <div key={`desktop-${index}`} className="flex flex-col w-85 bg-[#3A5867] p-7 rounded-4xl shadow-2xl">
              <img src={card.image} className="rounded-3xl shadow-2xl w-full" alt={card.title} />
              <h2 className="text-white text-2xl pt-5 font-semibold">{card.title}</h2>
            </div>
          ))}
        </div>
      )}

      {/* Mobile View - slider con react-slick */}
        {isMobile && (
        <div className="slider-container">
            <Slider {...sliderSettings}>
            {cards.map((card, index) => (
                <div key={`mobile-${index}`} className="flex justify-center items-center px-2">
                <div className="flex flex-col bg-[#3A5867] p-7 rounded-4xl shadow-2xl w-full max-w-xs">
                    <img src={card.image} className="rounded-3xl shadow-2xl w-full" alt={card.title} />
                    <h2 className="text-white text-2xl pt-5 font-semibold text-center">{card.title}</h2>
                </div>
                </div>
            ))}
            </Slider>
        </div>
        )}
    </div>
  );
};

export default CardSlider;